import { Injectable } from "@angular/core";
import { ExportToCsv } from 'export-to-csv';
import { Observable } from 'rxjs';
import { saveAs } from 'file-saver';
import { DPO_CONSTANT } from '../utils/constant';

// CSV Service to handle the creation and download on the CSV file
@Injectable()
export class CsvService {

    constructor() { }

    // Method to prepare and save the CSV file based on passed data
    public save(csvHeaders: string[], dataToProcess: any, fileName: string): any {

        //POUDG-8890: Needed to fetch language from localstorage/seseesion storage in browser
        // based on the langauge needed to set the fieldSeparator
        const a = localStorage.getItem(DPO_CONSTANT.CACHE_I18N_LOCALE);
        let seperator: any = null;
        if (a === 'en-GB' || a === 'ja-JP' || a === 'ko-KR') {
            seperator = ',';
        } else {
            seperator = ';';
        }
        //POUDG-8890:  End

        const options = {
            filename: fileName + '_export_' + new Date().getTime(),
            fieldSeparator: seperator,                                //POUDG-8890: changed delimiter
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: false,
            headers: csvHeaders
        };
        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(dataToProcess);
    }
}